// extracted by mini-css-extract-plugin
export default {"percent_button_block":"PercentButtonBlock_percent_button_block__LIZdq"};